/**
 * The Rotom Phone's Stats app: the player's own data, from the read views a player tier may read — `/me`'s
 * sections, restyled as an app (plan §9.11). The page itself is `MyProfilePage`; this only puts a player's
 * way in where a staff sign-in prompt would otherwise be.
 */
import { useSession } from '../auth/SessionProvider';
import { SignInButton } from '../components/SessionBar';
import { MyProfilePage } from '../pages/MyProfilePage';

export function StatsApp(): React.JSX.Element {
  const { session, self, selfChecking } = useSession();
  // A player this device remembers (the renewal behind `self`) needs no sign-in to read their own stats.
  if (session === null && self === null && !selfChecking) return <StatsWayIn />;
  return <MyProfilePage />;
}

/**
 * Signed out, in a player's words. Two doors, both proving who the reader plays as: the link `/audio`
 * prints in game (its claim carries a player session), and Discord for an account `/link` has bound. It
 * issues no query — a doomed read is a console full of 401s and somebody else's rate limit spent.
 */
function StatsWayIn(): React.JSX.Element {
  // A refused sign-in is said once, by the phone's shell, over whichever app is open.
  return (
    <section className="ph-stats-wayin dc-card" data-testid="sign-in-panel">
      <h2 className="ph-setting-title">Your stats, on your phone</h2>
      <p>Your homes, your queued rewards, your bases and your gifts, as the server has them — only yours, and only to read.</p>
      <ol className="ph-stats-doors">
        <li>
          Type <kbd>/audio</kbd> in game and open the link: it signs this phone in as you.
        </li>
        <li>
          Or, if you linked your Discord with <kbd>/link</kbd>: <SignInButton returnTo="/me" compact />
        </li>
      </ol>
    </section>
  );
}
